var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2.965 6.093a11.361 11.361 0 0 0 4.942 4.942l1.65-1.65a.746.746 0 0 1 .765-.18c.84.277 1.748.428 2.678.428.412 0 .75.337.75.75V13c0 .412-.338.75-.75.75C5.957 13.75.25 8.043.25 1 .25.588.588.25 1 .25h2.625c.412 0 .75.338.75.75 0 .938.15 1.837.428 2.678a.753.753 0 0 1-.188.764l-1.65 1.65Z"
  })));
};
export default SvgPhone;